<!-- <ion-header class="ion-no-border">
    <ion-title>
        <ion-label>{{"add_your_post" | translate}}</ion-label>
    </ion-title>
    <ion-icon src="../../../assets/svg/close.svg" (click)="closeModal()"
        class="close-button button-clear">
    </ion-icon>
</ion-header> -->
<ion-card class="headmodal">
    <span class="titlemodal">
        {{"add_your_post" | translate}}
    </span>
    <ion-button class="close-button" (click)="closeModal()">
        <ion-icon color="primary" name="close-outline"></ion-icon>
    </ion-button>
</ion-card >

    <ion-card class="ion-text-start contentcard" style="padding: 10px 10px 10px 10px;">
        
        <form [formGroup]="postForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <ion-input type="hidden" class="hideThis" [(ngModel)]="customer_id" formControlName="customer_id"></ion-input>
            <ion-textarea formControlName="content" rows="5" placeholder="{{'enter_content' | translate}}"
                [autoGrow]="true" class="popleft">
            </ion-textarea>
            <ion-card class="upload openclear"  (click)="openCameraORGallery()">
                <ion-input type="hidden" class="hideThis" [(ngModel)]="attachment" formControlName="attachment"></ion-input>
                <ion-label class="uploadItem">
                    <div class="uploadInner">{{"upload_image" | translate}}
                   
                    <ng-container
                        *ngIf="attachment_img;else no_attachment">
                        <ion-list lines="none" class="ion-text-center upload-card">
                            <ion-item class="uploaded-item">
                                <ion-thumbnail>
                                    <img [src]="attachment_img" />
                                </ion-thumbnail>
                                <ion-icon slot="end" size="small" color="danger" name="trash"
                                    ></ion-icon>
                            </ion-item>
                        </ion-list>
                    </ng-container>
                    <ng-template #no_attachment>
                        <ion-icon 
                        src="assets/svg/edit.svg"></ion-icon>
                    </ng-template>
                    </div>
                    <small>{{"supported_formats" | translate}} JPEG, PNG, GIF</small>
                </ion-label>
            </ion-card>
            <ion-button type="submit" [disabled]="postForm.invalid" shape="round" fill="solid" expand="full">
                <ng-container *ngIf="loading">
                    <ion-spinner dir="ltr" name="dots"></ion-spinner>
                </ng-container>
                {{"submit" | translate}}
            </ion-button>
        </form>
    </ion-card>
